module.exports = __webpack_public_path__ + "img/experience03.c7835863.jpg";